import React, { useEffect, useRef, useState, useCallback } from "react";
import "./Projects.css";
import { projects } from "../../data";
import Card from "./Card";

const tabs = [
  { name: "All" },
  { name: "AWS" },
  { name: "Desktop Application" },
  { name: "Mobile Application" },
];

const Projects = () => {
  const [displayableProjects, setDisplayableProjects] = useState(projects);
  const [activeIndex, setActiveIndex] = useState(0);
  const [offset, setOffset] = useState(0);
  const [indicatorWidth, setIndicatorWidth] = useState(0);
  const itemsEls = useRef([]);
  const updateIndicator = useCallback(() => {
    const el = itemsEls.current[activeIndex];
    if (!el) return;
    setOffset(el.offsetLeft);
    setIndicatorWidth(el.offsetWidth);
  }, [activeIndex]);
  useEffect(() => {
    updateIndicator();
  }, [updateIndicator]);
  useEffect(() => {
    const onResize = () => requestAnimationFrame(updateIndicator);
    window.addEventListener("resize", onResize);
    window.addEventListener("load", onResize);

    requestAnimationFrame(updateIndicator);

    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("load", onResize);
    };
  }, [updateIndicator]);

  const setProjects = (category) => {
    if (category === "All") {
      return setDisplayableProjects(projects);
    }
    const pro = projects.filter(
      (item) => item.category.toLowerCase() === category.toLowerCase()
    );
    setDisplayableProjects(pro);
  };

  return (
    <section id="projects">
      <div className="section__wrapper projects__container">
        <div className="section__header center">
          <h2 className="primary__title">Projects</h2>
        </div>

        <nav className="tabs">
          {tabs.map((tab, index) => (
            <button
              key={index}
              ref={(el) => (itemsEls.current[index] = el)}
              onClick={() => {
                setActiveIndex(index);
                setProjects(tab.name);
              }}
              className={index === activeIndex ? "active" : ""}
              type="button"
            >
              {tab.name}
            </button>
          ))}

          <span
            className="active__indicator"
            style={{
              left: `${offset}px`,
              width: `${indicatorWidth}px`,
            }}
          />
        </nav>

        <div className="card__container">
          {displayableProjects.map((p, index) => (
            <Card
              key={p.id ?? index}
              title={p.title}
              image={p.image}
              data={p.data}
              stack={p.stack}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
